import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { SavingParameters, ScheduleDate, LoanScheduleDate, CompanyRef, Range, Parameter, LoanParameters, PermanentSavingsLogic } from '@akiba/models_bimbo';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload.service';
import { DataSourceService } from '../../../services/data-source.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog, MatSelectChange, MatDatepickerInputEvent, MatTable, MatInput } from '@angular/material';
import { LogicService } from '../../../services/logic.service';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { Moment } from 'moment';
import * as moment from 'moment';
import { Installment } from '@akiba/models_bimbo';
import { SelectionModel } from '@angular/cdk/collections';
import { NgModel } from '@angular/forms';
import { isUndefined } from 'util';

@Component({
  selector: 'app-permanent-savings-loan-parameters',
  templateUrl: './permanent-savings-loan-parameters.component.html',
  styleUrls: ['./permanent-savings-loan-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PermanentSavingsLoanParametersComponent implements OnInit, OnDestroy {

  modParameter: Parameter | null = null;
  savingParameters: Array<Parameter> = new Array<Parameter>();
  parameterSubscription: Subscription;
  //////////////////////////////////
  //////////////////////////////////

  @ViewChild('installmentsTable', { static: false }) installmentsTable: MatTable<Installment>;
  @ViewChild('loanDatesTable', { static: false }) loanDatesTable: MatTable<LoanScheduleDate>;
  @ViewChild('companiesTable', { static: false }) companiesTable: MatTable<CompanyRef>;
  @ViewChild('rangeTable', { static: false }) rangeTable: MatTable<LoanParameters>;

  @ViewChild('weeklySavingInterestsRateControl', { static: false }) weeklySavingInterestsRateControl: NgModel;
  @ViewChild('weeklyNonSavingInterestsRateControl', { static: false }) weeklyNonSavingInterestsRateControl: NgModel;
  @ViewChild('biWeeklySavingInterestsRateControl', { static: false }) biWeeklySavingInterestsRateControl: NgModel;
  @ViewChild('biWeeklyNonSavingInterestsRateControl', { static: false }) biWeeklyNonSavingInterestsRateControl: NgModel;
  @ViewChild('extraLoanPercentage', { static: false }) extraLoanPercentage: NgModel;
  @ViewChild('extraLoanFALPPercentage', { static: false }) extraLoanFALPPercentage: NgModel;

  displayedLoanDatesColumns: string[] = ['InicioPrestamo', 'FinPrestamo', 'active', 'delete'];
  displayedInstallmentsColumns: string[] = ['weeks', 'biWeeks', 'months', 'select'];
  displayedCompanyColumns: string[] = ['companyID', 'companyName', 'taxationIdentificationNumber', 'select'];
  seniorityRangeColumns: string[] = ['start', 'end', 'edit', 'delete'];

  selectionInstallmentsSubscription: Subscription = null;
  selectionCompaniesSubscription: Subscription = null;
  appLogicChangesSubscription: Subscription = null;

  selectionInstallments: SelectionModel<Installment>;

  isEndDate = false;
  dateMaxPayments: any;
  existDate = false;
  isEdit = false;
  selectedIndex = 0;
  contentLocation: AppState = new AppState();

  tempPeriod: SavingParameters | null = null;
  originalParameters: SavingParameters | null = null;
  uploadSubscription: Subscription = null;

  newRLoanDate = new LoanScheduleDate();
  newLoanParameter: LoanParameters;
  editIndex = -1;

  constructor(public authService: AuthenticationService, private uploadService: UploadService, private dataService: DataSourceService, public dialog: MatDialog, public logicService: LogicService) {

    this.selectionInstallments = new SelectionModel<Installment>(false, []);
    this.newRLoanDate.startDate = null;
    this.newRLoanDate.endDate = null;

    if (!this.logicService.dataManager.parameterDataLoader.parameters) {

      this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

        if (p && p.response) {
          this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 2);
        }

      });

      this.logicService.dataManager.parameterDataLoader.load();

    } else {

      this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 2);

    }

  }

  ngOnInit() {
    
  }

  //////////////////////////////////

  setRegistrationDate(type: string, event: MatDatepickerInputEvent<Moment>) {

    if (type === 'starts') {

      this.newRLoanDate.startDate = event.value.toDate();

      this.newRLoanDate.weekNumber = event.value.isoWeek();
      const isoWeek = event.value.isoWeek() / 2;
      this.newRLoanDate.biWeekNumber = Math.ceil(isoWeek);

    } else if (type === 'ends') {

      if (!this.newRLoanDate.startDate) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'La necesario especificar la fecha de fin de ciclo.',
            close: 'Aceptar'
          }
        });

        this.newRLoanDate.endDate = null;

        return false;

      }

      const sM = moment(this.newRLoanDate.startDate);
      const eM = event.value;

      if (eM.isSameOrBefore(sM, 'day')) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'La fecha de fin de ciclo no puede ser el mismo dia que la fecha de inicio.',
            close: 'Aceptar'
          }
        });

        this.newRLoanDate.endDate = null;
        return false;

      }

      this.newRLoanDate.endDate = eM.toDate();

    }

  }

  addDate() {

    if (!this.newRLoanDate.startDate || !this.newRLoanDate.endDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Toda la fechas del de ciclo son requeridas.',
          close: 'Aceptar'
        }
      });

      return;

    }

    this.newRLoanDate.active = true;
    this.newLoanParameter.loanDates.push(this.newRLoanDate);
    this.newRLoanDate = new LoanScheduleDate();
    this.newRLoanDate.startDate = null;
    this.newRLoanDate.endDate = null;

    if (this.loanDatesTable) {
      this.loanDatesTable.renderRows();
    }

  }

  deleteLoanDate(index: number) {

    this.newLoanParameter.loanDates.splice(index, 1);
    this.loanDatesTable.renderRows();

  }

  //////////////////////////////////

  onChangeFalp() {
    if (!this.newLoanParameter.extraLoanFALPAllowed) {
      this.newLoanParameter.extraLoanFALPPercentage = null;
    } else {
      this.newLoanParameter.extraLoanFALPPercentage = 0;
    }
  }

  onChange() {

    if (!this.newLoanParameter.extraLoanAllowed) {
      this.newLoanParameter.extraLoanPercentage = null;
    } else {
      this.newLoanParameter.extraLoanPercentage = 0;
    }

  }

  //////////////////////////////////

  deleteInstallments(index: number) {
    const temp = this.logicService.dataManager.parameterDataLoader.installments;
    temp.splice(index, 1);
    this.logicService.dataManager.parameterDataLoader.installments = temp;
  }

  deleteLoanParameter(index: number) {
    const temp = this.modParameter.loansParameters;
    temp.splice(index, 1);
    this.modParameter.loansParameters = temp;
    if (this.rangeTable) {
      this.rangeTable.renderRows();
    }
  }

  editLoanParameter(index: number) {
    this.dateMaxPayments = undefined;
    this.editIndex = index;
    this.cancelSubscriptions();
    this.newLoanParameter = this.modParameter.loansParameters[index];
    this.dateMaxPayments = this.newLoanParameter.dateMaxPayments;
    this.existDate = this.dateMaxPayments != null ? true : false;
    this.isEndDate = false;
    
    this.doSubscriptions();
  }


  /////////////fecha fin alterna 

  activateEndDate(event) {
    this.isEndDate = event;
    if (this.dateMaxPayments) {
      this.dateMaxPayments = undefined;
    }

    if (event == false) {
      this.dateMaxPayments = undefined;
    }
  }

  deleteDateLoan(event) {

    if (event == this.dateMaxPayments) {
      this.dateMaxPayments = undefined;
      this.existDate = false;
    }

  }

  //////////////////////////////////

  addSeniorityRange() {
    this.isEdit = true;
    this.cancelSubscriptions();
    this.newLoanParameter = new LoanParameters();
    this.doSubscriptions();

  }

  get applicableLoanParameter(): LoanParameters | null {

    if (!this.modParameter) {
      return null;
    }

    return this.modParameter.applicableLoanParameter;

  }

  set applicableLoanParameter(value: LoanParameters | null) {
    this.modParameter.applicableLoanParameter = value;
  }

  //////////////////////////////////

  selectedPeriodChange(event: MatSelectChange) {

    this.newLoanParameter = undefined;
    this.isEndDate = false;
    if (!event.value) {
      this.reset();
    } else {
      this.isEdit = true;
      this.modParameter = event.value;
      this.tempPeriod = event.value;
    }

    
  }

  switchTo(anIndex: number) {
    this.contentLocation.savingParametersIndex = anIndex;
  }

  saveEditedPeriod() {


    if (this.dateMaxPayments && (this.dateMaxPayments instanceof Date) === false) {
      this.newLoanParameter.dateMaxPayments = this.dateMaxPayments.toDate();
    } else if (this.dateMaxPayments == undefined) {
      this.newLoanParameter.dateMaxPayments = null;
    }

    const authUser = this.logicService.dataManager.principalDataLoader.employee ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
    if (this.newLoanParameter.applicableSeniorityRange.start === null || this.newLoanParameter.applicableSeniorityRange.end === null) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que se añada al menos una rango de antigüedad al periodo.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.newLoanParameter.loanDates.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que se añada al menos una fecha al periodo.',
          close: 'Aceptar'
        }
      });
      return;

    }

    if (this.newLoanParameter.extraLoanAllowed) {

      if (this.newLoanParameter.extraLoanPercentage > 100 || this.newLoanParameter.extraLoanPercentage < 1) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'El porcentaje del ahorro acumulado es inválido.',
            close: 'Aceptar'
          }
        });
        return;
      }

    }

    if (this.newLoanParameter.extraLoanFALPAllowed) {

      if (this.newLoanParameter.extraLoanFALPPercentage > 100 || this.newLoanParameter.extraLoanFALPPercentage < 1) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'El porcentaje FALP es inválido',
            close: 'Aceptar'
          }
        });
        return;
      }

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar el ciclo con la información dada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });



    dialogConfirmation.afterClosed().subscribe(result => {

      if (result) {
        let createDate = new Date();
        let paramLogs = {
          changeID: '',
          collection: 'parameters',
          approvedUid: authUser.uid,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };

        if (this.editIndex !== -1) {
          this.deleteLoanParameter(this.editIndex);
        }

        if (this.newLoanParameter.fileUploaded.file) {

          this.uploadService.pushUpload(this.newLoanParameter.fileUploaded);
          this.uploadSubscription = this.uploadService.downloadURLSubject.subscribe(downloadURL => {

            this.newLoanParameter.fileUploaded.file = null;
            this.newLoanParameter.fileUploaded.downloadURL = downloadURL;
            if (this.uploadSubscription && !this.uploadSubscription.closed) {
              this.uploadSubscription.unsubscribe();
              this.uploadSubscription = null;
            }

            this.modParameter.loansParameters.push(this.newLoanParameter);
            const aPeriodObj = this.modParameter.toAny();

            paramLogs.changeID = aPeriodObj.parametersID;

            this.dataService.saveLogAdministratorActions(paramLogs, 'permanentSavingsLoanParametersFileUploaded').catch;
            
            this.dataService.saveParameter(aPeriodObj).then(() => {
              this.contentLocation.savingParametersIndex = 0;
              this.reset();
              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'La información ha sido actualizada',
                  close: 'Aceptar'
                }
              });

            });

          });

        } else {

          this.modParameter.loansParameters.push(this.newLoanParameter);
          const aPeriodObj = this.modParameter.toAny();
          paramLogs.changeID = aPeriodObj.parametersID;

          this.dataService.saveLogAdministratorActions(paramLogs, 'permanentSavingsLoanParameters');
          this.dataService.saveParameter(aPeriodObj).then(() => {

            this.contentLocation.savingParametersIndex = 0;
            this.reset();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada',
                close: 'Aceptar'
              }
            });

          });

        }

      }

    });

  }

  cancelPeriodChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this.reset();
      }
    });

  }

  reset() {

    this.cancelSubscriptions();
    this.editIndex = -1;
    this.modParameter = undefined;
    // this.permanentSavingsLogic.modifiablePeriod = null;
    this.isEndDate = false;
    this.dateMaxPayments = undefined;
    this.newLoanParameter = null;
    this.contentLocation.savingParametersIndex = 0;
    this.isEdit = false;
    this.tempPeriod = null;

    this.newRLoanDate = new LoanScheduleDate();
    this.newRLoanDate.startDate = null;
    this.newRLoanDate.endDate = null;

    this.selectionInstallments.clear();

    if (this.weeklySavingInterestsRateControl) {
      this.weeklySavingInterestsRateControl.reset(0);
    }

    if (this.weeklyNonSavingInterestsRateControl) {
      this.weeklyNonSavingInterestsRateControl.reset(0);
    }

    if (this.biWeeklySavingInterestsRateControl) {
      this.biWeeklySavingInterestsRateControl.reset(0);
    }

    if (this.biWeeklyNonSavingInterestsRateControl) {
      this.biWeeklyNonSavingInterestsRateControl.reset(0);
    }

    if (this.extraLoanPercentage) {
      this.extraLoanPercentage.reset(0);
    }

    if (this.extraLoanFALPPercentage) {
      this.extraLoanFALPPercentage.reset(0);
    }

  }

  doSubscriptions() {

    if (this.logicService.dataManager.parameterDataLoader.installments && this.logicService.dataManager.parameterDataLoader.installments.length) {

      if (this.selectionInstallmentsSubscription && !this.selectionInstallmentsSubscription.closed) {
        this.selectionInstallmentsSubscription.unsubscribe();
        this.selectionInstallmentsSubscription = null;
      }

      this.selectionInstallments = new SelectionModel<Installment>(false, []);

      this.logicService.dataManager.parameterDataLoader.installments.forEach(element => {
        if (this.modParameter && this.newLoanParameter &&
          this.newLoanParameter.maxPayments && this.newLoanParameter.maxPayments.installmentID === element.installmentID) {
          this.selectionInstallments.select(element);
        }
      });

      this.selectionInstallmentsSubscription = this.selectionInstallments.changed.subscribe(x => {
        if (x.added.length) {
          this.newLoanParameter.maxPayments = x.added[0];
        } else if (x.removed.length) {
          this.newLoanParameter.maxPayments = null;
        }
      });

      if (this.installmentsTable) {
        this.installmentsTable.renderRows();
      }

    }

    if (this.installmentsTable) {
      this.installmentsTable.renderRows();
    }

    if (this.loanDatesTable) {
      this.loanDatesTable.renderRows();
    }

    if (this.applicableLoanParameter) {

      if (!this.modParameter.applicableLoanParameter.extraLoanAllowed) {
        this.modParameter.applicableLoanParameter.extraLoanPercentage = null;
      }

      if (!this.modParameter.applicableLoanParameter.extraLoanFALPAllowed) {
        this.modParameter.applicableLoanParameter.extraLoanFALPPercentage = null;
      }

    }

  }

  cancelSubscriptions() {

    if (this.selectionInstallmentsSubscription && !this.selectionInstallmentsSubscription.closed) {
      this.selectionInstallmentsSubscription.unsubscribe();
      this.selectionInstallmentsSubscription = null;
    }

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
      this.selectionCompaniesSubscription = null;
    }

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
      this.appLogicChangesSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }

    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

  }

  ngOnDestroy(): void {
    this.cancelSubscriptions();
  }

}
